/** One key per logical canonical member mutation; an axios retry reuses its headers. */
export function needsMemberMutationKey(
    url: string | undefined,
    method: string | undefined,
): boolean {
    try {
        return (
            /^\/api\/ai\/admin\/members(?:\/|$)/.test(
                new URL(url ?? "", window.location.origin).pathname,
            ) && ["POST", "PUT", "PATCH", "DELETE"].includes((method ?? "GET").toUpperCase())
        );
    } catch {
        return false;
    }
}
export function newMutationKey(): string {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
